import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const GOOGLE_ANALYTICS_ID = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (!GOOGLE_ANALYTICS_ID) return;

    // Initialize GA script if not already present
    const scriptId = 'ga-gtag';
    if (!document.getElementById(scriptId)) {
      const script = document.createElement('script');
      script.id = scriptId;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      const gtag = function() {
        window.dataLayer.push(arguments);
      };
      gtag('js', new Date());
      gtag('config', GOOGLE_ANALYTICS_ID);
      
      // Save gtag to window for subsequent calls
      window.gtag = gtag;
    }
  }, []);

  useEffect(() => {
    if (!GOOGLE_ANALYTICS_ID) return;
    
    // If window.gtag exists, send the page view
    if (window.gtag) {
      window.gtag('config', GOOGLE_ANALYTICS_ID, {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
};

export default GoogleAnalytics;
